module.exports = __webpack_public_path__ + "static/media/ic_danger.631b24e5.svg";